import axios from 'axios';

import router from '@/router';
import { tokenName } from './useAuth';
import useEcho from './useEcho';

export const baseURL = process.env.VUE_APP_BACKEND_HOST || 'https://backend-dev.xgen-live.ideavivat-demo.com/api';

export default function useAxios() {
  const { pusher } = useEcho();
  const axiosInstance = axios.create({
    baseURL,
    // headers: headers
  });

  if (localStorage.getItem(tokenName)) {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${localStorage.getItem(tokenName)}` };
  } else if (sessionStorage.getItem(tokenName)) {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${sessionStorage.getItem(tokenName)}` };
  }

  axiosInstance.interceptors.response.use((response) => {
    if (response.status === 401) {
      console.log('status 401');
    }
    return response;
  }, (error) => {
    if ((error.message) || (error.response && error.response.data)) {
      if (error.response.data.status === 'Token is Expired' || error.response.data.status === 'Token is Invalid') {
        if (localStorage.getItem(tokenName)) {
          localStorage.removeItem(tokenName);
          localStorage.removeItem(`${tokenName}-expire`);
        }
        if (sessionStorage.getItem(tokenName)) {
          sessionStorage.removeItem(tokenName);
          sessionStorage.removeItem(`${tokenName}-expire`);
        }
        if ((router as any).apps[0]._route.name !== 'Login') {
          console.error(error);
          router.push({ name: 'Login' });
        }
        // if (window.location.href.indexOf('Login') <= -1) window.location.href = 'login';
      }
    }
    return error.response;
  });

  const setAuthorization = async (token: string) => {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${token}` };
    if (pusher && pusher.config.auth) pusher.config.auth.headers['Authorization' as any] = `Bearer ${token}`;
  };

  return {
    axios: axiosInstance,
    setAuthorization,
  };
}
